import { render, staticRenderFns } from "./SignupPage.vue?vue&type=template&id=e444947a&scoped=true"
import script from "./SignupPage.vue?vue&type=script&lang=js"
export * from "./SignupPage.vue?vue&type=script&lang=js"
import style0 from "./SignupPage.vue?vue&type=style&index=0&id=e444947a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e444947a",
  null
  
)

export default component.exports